import React, { Children, cloneElement, isValidElement } from 'react';

const textOf = node => Children.toArray(node).map(child => {
    if (typeof child === 'string' || typeof child === 'number') return child;
    return isValidElement(child) ? textOf(child.props.children) : '';
}).join('').trim();

// Keep the existing table and its actions on desktop. On phones each row uses
// the same column headings as labels, including headings changed by filters.
export default function ResponsiveTable({ children, className = '', ...props }) {
    const expenseRecords = className.split(/\s+/).includes('expense-records');
    const sections = Children.toArray(children);
    const head = sections.find(child => isValidElement(child) && child.type === 'thead');
    const rows = Children.toArray(head?.props.children).filter(isValidElement);
    const headings = Children.toArray(rows[0]?.props.children).filter(isValidElement);
    const cards = rows.length === 1 && headings.every(h => !h.props.colSpan && !h.props.rowSpan);
    const sortable = headings.filter(h => h.props.onClick);
    const labelled = sections.map(section => {
        if (!cards || !isValidElement(section) || section.type !== 'tbody') return section;
        return cloneElement(section, {}, Children.map(section.props.children, row => {
            if (!isValidElement(row) || row.type !== 'tr') return row;
            return cloneElement(row, {}, Children.toArray(row.props.children).map((cell, index) => {
                if (!isValidElement(cell) || cell.type !== 'td' || cell.props.colSpan > 1) return cell;
                return cloneElement(cell, { 'data-label': cell.props['data-label'] || textOf(headings[index]?.props.children) },
                    expenseRecords ? <div className="expense-cell-value">{cell.props.children}</div> : cell.props.children);
            }));
        }));
    });
    return <>
        {cards && sortable.length > 0 && <div className="mobile-table-sort" aria-label="Sort rows">
            <span>Sort by</span>
            {sortable.map((heading, index) => <button type="button" key={index} onClick={heading.props.onClick}>
                {heading.props.children}
            </button>)}
        </div>}
        <table {...props} className={`${className} responsive-table`} data-mobile-layout={cards ? 'cards' : 'scroll'}>
            {labelled}
        </table>
    </>;
}
